import React, { useEffect, useState } from "react";
import "./modalP.scss";
import { Button, Typography } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import Collapse from "@material-ui/core/Collapse";
import { Levels } from "react-activity";
import { useHistory } from "react-router";
import ViewAddress from "./ViewAddress";
import PaypalBtn from "../../Services/PaypalBtn";
import UserData from "./userData";
import requests from "../../Services/HttpServices";
import { readPendingRecharge, savePendingRecharge, clearPendingRecharge } from '../../Services/CreditPaymentRecovery';
import "react-activity/dist/react-activity.css";


const parseAmount = (amount) => {
	const parsed = parseFloat(amount);
	return Number.isNaN(parsed) ? 0 : parsed;
};

const formatAmount = (amount) => parseAmount(amount)
	.toFixed(2)
	.replace(".", ",");

const getLoggedUser = () => {
	try {
		return sessionStorage.getItem("User") && JSON.parse(sessionStorage.getItem("User")).userdata;
	} catch (e) {
		return null;
	}
};

export default function ReactPayPal(props) {
	let taxAddress;
	let taxAddressNationalityFlag               = false;
	let shippingNationalityFlag                 = false;
	const history                               = useHistory();
	const [label, setLabel]                     = useState(null);
	const [loading, setLoading]                 = useState(null);
	const [buttonClicked, setButtonClicked]     = useState(null);
	const [success, setSuccess]                 = useState(null);
	const [addressVisible, setAddressVisible]   = useState(false);
	const [userDataVisible, setUserDataVisible] = useState(false);
	const [dataVisible, setDataVisible]         = useState(false);
	const [creditQuote, setCreditQuote]         = useState(null);
	const [creditError, setCreditError]         = useState("");
	const [creditLoading, setCreditLoading]     = useState(false);
	const [paymentReceipt, setPaymentReceipt]   = useState(null);
	const [pendingPaypal, setPendingPaypal] = useState(() => {
		const pending = readPendingRecharge(getLoggedUser()?.user_id);
		return pending && Number(pending.orderid) === Number(props.orderId) ? pending : null;
	});

	!label && setLabel("QrCode + Pagina Ricordo + Spedizione\n Quantità: 1");
	const effectivePrice = props.price || "1";
	const hasPartnerPrice = props.isPartnerPrice && props.originalPrice && parseFloat(props.originalPrice) > 0;
	const loggedUser = getLoggedUser();
	const isCreditRecharge = props.paymentType === "credits-recharge";
	const requiresReceiptContinue = ["qrCode", "dedic", "memorial"].includes(props.paymentType);
	const hideUserData = props.paymentType === "funeral-gift";
	const canUseCredits = !isCreditRecharge && !!loggedUser && !!props.orderId;
	const totalAmount = creditQuote && creditQuote.total ? parseAmount(creditQuote.total) : parseAmount(effectivePrice);
	const availableCredits = creditQuote ? parseAmount(creditQuote.balance) : 0;
	const hasSufficientCredits = canUseCredits && availableCredits >= totalAmount && totalAmount > 0;
	const paypalAmount = isCreditRecharge ? totalAmount : 0;

	useEffect(() => {
		if (!canUseCredits) {
			setCreditQuote(null);
			setCreditError("");
			setCreditLoading(false);
			return;
		}

		setCreditLoading(true);
		requests("get", "creditOrderQuote", props.orderId)
			.then((result) => {
				const quote = result && result.data && result.data.data;
				if (result && result.data && result.data.response === "success" && quote) {
					setCreditQuote(quote);
					setCreditError("");
				} else {
					setCreditQuote(null);
				setCreditError(result?.data?.message || "Impossibile verificare il saldo crediti.");
				}
				setCreditLoading(false);
			})
			.catch(() => {
				setCreditQuote(null);
			setCreditError("Impossibile verificare il saldo crediti.");
				setCreditLoading(false);
			});
	}, [canUseCredits, props.orderId, props.price]);

	const completeSuccess = (data) => {
		if (!isCreditRecharge && data && data.data) setPaymentReceipt(data.data);
		setSuccess(true);
		if (props.onSuccess) props.onSuccess(data);
	};

	const registerPaypal = async (payment) => {
		setLoading(true);
		setCreditError('');
		try {
			const result = await requests('post', 'paypalUpdate', { orderid: payment.orderid, paypal_order_id: payment.paypal_order_id });
			if (result?.response !== 'success') throw new Error(result?.message || 'Registrazione della ricarica non completata.');
			clearPendingRecharge(loggedUser?.user_id);
			setPendingPaypal(null);
			completeSuccess(result);
		} catch (error) {
			setCreditError(`${error.message} Il pagamento PayPal è già stato eseguito: riprova la registrazione, senza pagare di nuovo.`);
		} finally { setLoading(false); }
	};

	const payWithCredits = () => {
		if (!hasSufficientCredits) return;
		setLoading(true);
		setButtonClicked(true);
		setCreditError("");
		if (props.setError) props.setError(false);
		const bodyData = {
			orderid : props.orderId,
			expectedAmount: creditQuote.total,
		};
		requests("post", "creditPayOrder", bodyData).then((data) => {
			if (data.response === "success") {
				completeSuccess(data);
			} else {
				setLoading(false);
				setCreditError(data.message || "Pagamento con crediti non riuscito.");
			}
		}).catch(() => {
			setLoading(false);
			setCreditError("Pagamento con crediti non riuscito.");
		});
	};

	if (props.taxAddress && props.taxAddress.city !== "") taxAddress = props.taxAddress;
	else taxAddress = props.shippingAddress;

	if (
		props.shippingAddress
		&& props.shippingAddress.address !== ""
		&& props.shippingAddress.address
		&& props.shippingAddress.address === props.shippingAddress.civic
	) {
		shippingNationalityFlag = true;
	}
	if (taxAddress && taxAddress.address !== "" && taxAddress.address && taxAddress.address === taxAddress.civic) {
		taxAddressNationalityFlag = true;
	}
	return (
		<div className={`payment-main-modal${success && paymentReceipt ? " payment-receipt-modal" : ""}`}>
			{!loading ? (
				<div>
					<Typography className="header">Riepilogo ordine</Typography>
					<div id="purchase-detail">
						<div id="purchase-description">
							<Typography style={{ textTransform: "capitalize" }}>{props.purchase}</Typography>
							<Typography>
								Quantità:
								{props.quantity}
							</Typography>
						</div>
						<div id="price">
							{hasPartnerPrice ? (
								<div className="payment-price-stack">
									<Typography className="payment-original-price">
										{formatAmount(props.originalPrice)}
										{isCreditRecharge ? "€" : " Crediti"}
									</Typography>
									<Typography>
										{formatAmount(isCreditRecharge ? effectivePrice : totalAmount)}
										{isCreditRecharge ? "€" : " Crediti"}
									</Typography>
								</div>
							) : (
								<Typography>
									{formatAmount(isCreditRecharge ? effectivePrice : totalAmount)}
										{isCreditRecharge ? "€" : " Crediti"}
								</Typography>
							)}
						</div>
					</div>
					{!isCreditRecharge && (
						<div className="payment-credit-box">
							<Typography>Questo servizio si acquista tramite i Crediti DigitalMemorial.</Typography>
							{!loggedUser ? (
								<Typography className="payment-credit-insufficient">
									<a href="/login">Accedi</a> per continuare o ricaricare i crediti.
								</Typography>
							) : creditLoading ? (
								<Typography className="payment-credit-note">Verifica crediti disponibili...</Typography>
							) : creditQuote ? (
								<div className="payment-credit-summary">
									<div>
										<span>Totale ordine</span>
										<strong>{formatAmount(totalAmount)} Crediti</strong>
									</div>
									<div>
										<span>Crediti disponibili</span>
										<strong>{formatAmount(availableCredits)} Crediti</strong>
									</div>
									{!hasSufficientCredits && (
										<Typography className="payment-credit-insufficient">
											Mancano {formatAmount(totalAmount - availableCredits)} Crediti. Ricaricali nella <a href={String(loggedUser?.platformAccess) === "2" ? "/partner-panel#account" : "/client-panel#account"}>sezione Account</a>.
										</Typography>
									)}
								</div>
							) : null}
						</div>
					)}
					{creditError && <Typography className="payment-credit-error">{creditError}</Typography>}
					{!hideUserData && (
						<div id="collapsable-container" style={{ display: "flex", flexDirection: "column" }}>
							<div
								onClick={() => {
									setUserDataVisible(!userDataVisible);
								}}
								className="collapsable-list"
							>
								<div
									style={{
										display       : "flex",
										flexDirection : "row",
										margin        : "auto",
									}}
								>
									<label style={{ margin: "auto", paddingLeft: 24 }}>Dati utente</label>
									<div>{userDataVisible ? <ExpandLess /> : <ExpandMore />}</div>
								</div>
							</div>

							<Collapse in={userDataVisible} timeout="auto" unmountOnExit>
								<div style={{ display: "flex", justifyContent: "center" }}>
									<UserData userData={props.userData} />
								</div>
							</Collapse>
						</div>
					)}
					{props.showAddress && (
						<div id="collapsable-container" style={{ display: "flex", flexDirection: "column" }}>
							<div
								onClick={() => {
									setAddressVisible(!addressVisible);
								}}
								className="collapsable-list"
							>
								<div
									style={{
										display       : "flex",
										flexDirection : "row",
										margin        : "auto",
									}}
								>
									<label style={{ margin: "auto", paddingLeft: 24 }}>
										Dati indirizzo (spedizione)
									</label>
									<div>{addressVisible ? <ExpandLess /> : <ExpandMore />}</div>
								</div>
							</div>

							<Collapse in={addressVisible} timeout="auto" unmountOnExit>
								<div
									style={{
										display        : "flex",
										justifyContent : "center",
									}}
								>
									{shippingNationalityFlag ? (
										<div>
											{" "}
											<Typography className="p-y-10">
												<strong>Indirizzo:</strong>
												{` ${props.shippingAddress.address}`}
											</Typography>
										</div>
									) : (
										<ViewAddress noSearch={props.noSearch} address={props.shippingAddress} />
									)}
								</div>
							</Collapse>
						</div>
					)}
					<div
						id="collapsable-container"
						className="mb-40"
						style={{
							display       : "flex",
							flexDirection : "column",
						}}
					>
						<div
							onClick={() => {
								setDataVisible(!dataVisible);
							}}
							className="collapsable-list"
						>
							<div
								style={{
									display       : "flex",
									flexDirection : "row",
									margin        : "auto",
								}}
							>
								<label style={{ margin: "auto", paddingLeft: 24 }}>Dati indirizzo (fatturazione)</label>
								<div>{dataVisible ? <ExpandLess /> : <ExpandMore />}</div>
							</div>
						</div>

						<Collapse in={dataVisible} timeout="auto" unmountOnExit>
							<div style={{ display: "flex", justifyContent: "center" }}>
								{taxAddressNationalityFlag ? (
									<div>
										{" "}
										<Typography className="p-y-10">
											<strong>Indirizzo:</strong>
											{` ${taxAddress.address}`}
										</Typography>
									</div>
								) : (
									<ViewAddress address={taxAddress} noSearch={props.noSearch} />
								)}
							</div>
						</Collapse>
					</div>
				</div>
			) : (
				!success && (
					<div
						style={{
							display        : "flex",
							flexDirection  : "column",
							justifyContent : "center",
							alignItems     : "center",
							alignContent   : "center",
							height         : 250,
						}}
					>
						<Levels size={100} />
					</div>
				)
			)}

			<div style={{ display: (loading || success) ? "none" : undefined }} className="footer-modal">
				{!isCreditRecharge ? (
					<Button
						variant="contained"
						color="primary"
						className="payment-credit-button"
						disabled={creditLoading || !hasSufficientCredits}
						onClick={payWithCredits}
					>
						Paga con Crediti
					</Button>
				) : pendingPaypal ? (
					<Button onClick={() => registerPaypal(pendingPaypal)}>Completa registrazione ricarica già pagata</Button>
				) : (
					<PaypalBtn
						history={history}
						orderID={props.orderId}
						paymentType={props.paymentType}
						amount={paypalAmount.toFixed(2)}
						onClick={() => {
							setLoading(true);
							setButtonClicked(true);
							if (props.setError) props.setError(false);
						}}
						clientId={props.payClientId}
						currency="EUR"
						onSuccess={(details, data) => {
							const payment = { orderid: props.orderId, paypal_order_id: details.id || data.orderID, amount: paypalAmount };
							savePendingRecharge(loggedUser?.user_id, payment);
							setPendingPaypal(payment);
							registerPaypal(payment);
						}}
					/>
				)}
			</div>
			{success && !requiresReceiptContinue
				&& props.successComponent(props.isRegistering, props.isAccount, history)}
			{success && paymentReceipt && (
				<div className="payment-receipt" role="status">
					<Typography className="header">Pagamento completato</Typography>
					<Typography className="payment-receipt-note">Il pagamento con Crediti DigitalMemorial è stato effettuato.</Typography>
					<dl className="payment-receipt-details">
						<div><dt>Servizio</dt><dd className="payment-receipt-service">{String(props.purchase || '').replace(/-/g, ' ')}</dd></div>
						<div><dt>Crediti utilizzati</dt><dd><strong>{formatAmount(paymentReceipt.amount)}</strong></dd></div>
						{paymentReceipt.balance != null && <div><dt>Saldo residuo</dt><dd><strong>{formatAmount(paymentReceipt.balance)} Crediti</strong></dd></div>}
						{paymentReceipt.expirationDate && <div><dt>Scadenza</dt><dd>{paymentReceipt.expirationDate}</dd></div>}
					</dl>
					<Typography className="payment-receipt-reference">
						Ordine #{paymentReceipt.orderid}
						{paymentReceipt.deceasedID && <> · Memorial #{paymentReceipt.deceasedID}</>}
						{paymentReceipt.movementID && <> · Movimento #{paymentReceipt.movementID}</>}
					</Typography>
					{requiresReceiptContinue && (
						<Button className="payment-receipt-continue" variant="contained" color="primary" onClick={() => props.successComponent(props.isRegistering, props.isAccount, history)}>
							Continua
					</Button>
					)}
				</div>
			)}
		</div>
	);
}
